import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {  SkuDropDownData } from './sku-drop-down-model';

export class SkuDropDownDataResponseModel extends GlobalResponseObject{
    data?: SkuDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //SkuDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: SkuDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
